import { isNil } from "lodash";
import { useEffect } from "react";

const ROW_MARGIN = 8;

const rowSelector = "[data-zone-row]";

const scrollToRow = ({ side, zoneId }) => {
  const row = [...side.querySelectorAll(rowSelector)].find(
    (node) => node.dataset.zoneRow === zoneId,
  );
  if (isNil(row)) return;
  const head = row.closest("[data-group]")?.querySelector("[data-group-head]");
  side.scrollTo({
    top: Math.max(
      0,
      row.getBoundingClientRect().top -
        side.getBoundingClientRect().top +
        side.scrollTop -
        ROW_MARGIN -
        (head?.offsetHeight ?? 0),
    ),
    behavior: "smooth",
  });
};

const focusNextRow = ({ side, request }) => {
  const banner = side.querySelector("[data-all-settled]");
  if (request.fromSettle && !isNil(banner)) {
    banner.focus();
    return;
  }
  const acted = new Set(request.ids);
  const rows = [...side.querySelectorAll(rowSelector)];
  const usable = (node) =>
    !acted.has(node.dataset.zoneRow) && !node.hasAttribute("data-leaving");
  const index = rows.findIndex((node) => acted.has(node.dataset.zoneRow));
  if (index < 0 && !request.fromSettle) return;
  const next = rows.slice(Math.max(0, index)).find(usable) ?? rows.find(usable);
  const target =
    next?.querySelector("[data-row-primary]") ??
    next?.querySelector("[data-row-label]");
  target?.focus();
};

const useSideFocus = ({ sideRef, listFocus, focusRequest }) => {
  useEffect(() => {
    if (isNil(listFocus) || isNil(sideRef.current)) return;
    scrollToRow({ side: sideRef.current, zoneId: listFocus.zoneId });
  }, [sideRef, listFocus]);

  useEffect(() => {
    if (isNil(focusRequest) || isNil(sideRef.current)) return;
    focusNextRow({ side: sideRef.current, request: focusRequest });
  }, [sideRef, focusRequest]);
};

export default useSideFocus;
